"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hash = void 0;
const fnv = require("fnv-plus");
const hash = input => fnv.fast1a52hex(input);
exports.hash = hash;
//# sourceMappingURL=hash.js.map